export default {
  getDefaultValue: (data, tag, nest)  => {
    let returnValue = false;
    if(data && data[tag]) {
      //FORMAT
      // console.log(data[tag], tag, returnValue, "TAG")
      if(tag === 'gender') {
        if (data[tag].length === 2) returnValue = 'All'
        else returnValue = data[tag][0]
      }
      else if(tag === 'mutations') returnValue = data[tag][nest];
      else if(tag === 'p_score') returnValue = data[tag][data[tag].length-1];
      else if(tag === 'eligibility') {
        if(['minimum_age', 'maximum_age'].includes(nest)) {
          returnValue = data[tag][nest] ? data[tag][nest]/12 : (nest === 'minimum_age' ? '<1' : '>75')
        }
      }
      else if(nest) returnValue = data[tag][nest];
      else returnValue = data[tag];
    }
    else if(data && data[tag] === null) returnValue = 'N/A'
    return returnValue
  },
  parseAge: value => {
    let minAge, maxAge, age;
    if (Array.isArray(value)) {
      let newArray = [];
      value.forEach((val) => {
        if(val === '<1') minAge = '<1';
        else if(val === '>75') maxAge = '>75'
        else newArray.push(val)
      })
      newArray.sort((a, b) => a - b);
      if(!minAge) minAge = newArray[0];
      if (!maxAge) maxAge = newArray[newArray.length-1]
      // console.log(age, newArray, minAge, maxAge, "AGES")
    } else age = value;
    return {minAge, maxAge, age}
  },
  returnValue: (data, tag) => {
    let toReturn = '';
    if(tag === 'customEligibilityCriteria'){
      if(data.studyPopulation) toReturn = data.studyPopulation
      else if(data.custom && data.custom.eligibility) toReturn = data.custom.eligibility
      else toReturn = data.eligibilityCriteria
    }
    if(tag === 'customDescription') {
      if(data.customDescription) toReturn = data.customDescription
      else if(data.custom && data.custom.brief) toReturn = data.custom.brief
      else toReturn = data.briefDescription
    }
    if(tag === 'customPrimaryOutcome'){
      if(data.whatsInvolved) toReturn = data.whatsInvolved
      else if(data.custom && data.custom.outcomes) toReturn = data.custom.outcomes
      else toReturn = ''
    }
    if (tag === 'extraInfo' && data.extraInfo) {
      toReturn = data.extraInfo;
    }
    return toReturn
  }
}
